import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export interface Count {
  deleted: number;
  demolished: number;
}

@Component({
  selector: 'app-step-toggle',
  templateUrl: './step-toggle.component.html',
  styleUrls: ['./step-toggle.component.css']
})

export class StepToggleComponent {
  selected: string = '';
  @Input() selectedFilter: string;
  @Input() deleted_count: number;
  @Input() demolished_count: number;
  @Input() multi_parcel: number;
  @Input() review_count: number;
  @Input() entity_type: string;
  @Output() selectedOption = new EventEmitter();
  @Output() changeOption = new EventEmitter();
  constructor(iconRegistry: MatIconRegistry, public sanitizer: DomSanitizer, private readonly cdRef: ChangeDetectorRef) {
    iconRegistry.addSvgIcon('demolished', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/demolished.svg'))
      .addSvgIcon('active', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/active_building.svg'));
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.cdRef.detectChanges();
    }, 0);
  }

  ngOnChanges() {
    if (this.selectedFilter !== undefined && this.selectedFilter !== null) {
      this.selected = this.selectedFilter;
    }
  }

  isSelected(type: string) {
    return this.selected === type;
  }

  changeStatus(type: string) {
    // toggle selection
    let active = false;
    if (this.selected == type) {
      this.selected = '';
      active = false;
    } else {
      this.selected = type;
      active = true;
    }
    if (type == 'unit_map') {
      if (active) {
        this.selectedOption.emit('unit_map');
      } else {
        this.selectedOption.emit({ filter: 'unit_map', active: false });
      }
      this.changeOption.emit(this.selected !== '');
      return;
    }
    this.selectedOption.emit({ filter: type, active: active });
    this.changeOption.emit(this.selected !== '');
  }
}
